import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import ValidatedInput from '../../components/forms/ValidatedInput';
import VersionBox from '../../components/common/VersionBox';
import PreviewGeneralInfo from '../../components/preview/PreviewLogo';
import i18n from '../../i18n';

class GeneralInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = { data: false, showPreview: true, isChMSSyncWithDB : false };
        this.updateVersionFromEvent = this.updateVersionFromEvent.bind(this);
        this.setStateFromEvent = this.setStateFromEvent.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        const isUnity = localStorage.getItem('IsUnity');
        const hasPeople = this.checkForPeopleModule();
        if(isUnity === 'true' && hasPeople === true){
          this.props.versions.select.chMSIntegrations = true;
          this.props.actions.updateProjectVersionbyParameter(
            this.props.match.params.projectId,
            "chMSIntegrations",
            true,
        );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.data && !this.props.versions.inProgress) {
            const stateObj = {};
            stateObj.churchName = this.props.versions.select.churchName;
            stateObj.churchStreetAddress = this.props.versions.select.churchStreetAddress;
            stateObj.churchAddress = this.props.versions.select.churchAddress;
            stateObj.churchState = this.props.versions.select.churchState;
            stateObj.churchZip = this.props.versions.select.churchZip;
            stateObj.churchCity = this.props.versions.select.churchCity;
            stateObj.description = this.props.versions.select.description;
            stateObj.data = true;
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(stateObj);
        }
        
        if(!this.state.isChMSSyncWithDB && this.props?.versions?.select?.id) {
            const chMSValue = this.props?.versions?.select?.chMSIntegrations
            if(chMSValue === false) { // Need to check specific with False only
                // This condition will be disable the all module related to chms integration in case it was enabled by default
                // People, Integration, Group, Check-In and StudioC
                this.props.actions.updateProjectVersionbyParameter(
                    this.props.match.params.projectId,
                    "chMSIntegrations",
                    chMSValue,
                );
            }

             this.setState({
                isChMSSyncWithDB : true
             })
        }
    }

    checkForPeopleModule(){
      const modules = localStorage.getItem('ModulesData');
      const parsedModules = JSON.parse(modules);
      if (parsedModules !== null && parsedModules !== undefined){
          const hasPeople = parsedModules.find(e => e.name === 'People');
          if(hasPeople !== undefined){
              return true;
          }
      }
      return false;
  }

    setStateFromEvent(e, stateKey) {
        const stateObj = {};
        stateObj[stateKey] = e.target.value;
        this.setState(stateObj);
    }

    // eslint-disable-next-line class-methods-use-this
    getChurchInitials(church) { // eslint-disable-next-line
        if(typeof church != 'undefined') {
            return church.split(' ')
                .map((x) => { return x[0]; })
                .join('')
                .substring(0, 4);
        }

        return '';
    }

    updateVersionFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.value;
        if (changedValue !== this.props.versions.select[fieldName]) {
            this.updateVersionForFieldWithValue(fieldName, changedValue);
        }
    }

    updateVersionForFieldWithValue(field, val) {
        const version = this.props.versions.select;
        version[field] = val;
        this.props.actions.updateProjectVersionbyParameter(
            this.props.versions.select.projectId,
            field,
            val,
        );
    }

    render() {
        const version = this.props.versions.select;
        const logoPath = version.logoImage?.imagePath;
        const address = `${this.state.churchStreetAddress || ''} ${this.state.churchCity || ''}, ${this.state.churchState || ''} ${this.state.churchZip || ''}`;
        const previewGenInfo = (<PreviewGeneralInfo description={this.props.versions.select.description} logo={logoPath} church={typeof this.state.churchName !== 'undefined' ? this.state.churchName : ''} address={address} />);
        const form = (
            <div id="general-info-form" className="form-wrapper">
                <ValidatedInput
                    containerClass="input_church-name"
                    labelText={i18n.t('general.label1')}
                    value={this.state.churchName}
                    name="churchName"
                    placeholder={i18n.t('general.placeholder1')}
                    onBlur={(fn) => { this.updateVersionFromEvent(fn, false, 'churchName'); }}
                    onReturnDown={(fn) => { this.updateVersionFromEvent(fn, false, 'churchName'); }}
                    onChange={(e) => { return this.setStateFromEvent(e, 'churchName'); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                />
                <ValidatedInput
                    containerClass="input_app-description"
                    labelText={i18n.t('general.label2')}
                    value={this.state.description}
                    charLimit={4000}
                    name="description"
                    placeholder={i18n.t('general.placeholder2')}
                    shortHelpText={i18n.t('general.helptext2')}
                    onBlur={(fn) => { this.updateVersionFromEvent(fn, false, 'description'); }}
                    onReturnDown={(fn) => { this.updateVersionFromEvent(fn, false, 'description'); }}
                    onChange={(e) => { return this.setStateFromEvent(e, 'description'); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                    multiline
                />

                <ValidatedInput
                    containerClass="input_church-street-address"
                    labelText={i18n.t('general.meetingLocation')}
                    value={this.state.churchStreetAddress}
                    name="churchStreetAddress"
                    placeholder={i18n.t('general.streetAddress')}
                    onBlur={(fn) => { this.updateVersionFromEvent(fn, false, 'churchStreetAddress'); }}
                    onReturnDown={(fn) => { this.updateVersionFromEvent(fn, false, 'churchStreetAddress'); }}
                    onChange={(e) => { return this.setStateFromEvent(e, 'churchStreetAddress'); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                />

                <ValidatedInput
                    containerClass="input_church-city"
                    labelText={i18n.t('general.city')}
                    value={this.state.churchCity}
                    name="churchCity"
                    placeholder={i18n.t('general.city')}
                    onBlur={(fn) => { this.updateVersionFromEvent(fn, false, 'churchCity'); }}
                    onReturnDown={(fn) => { this.updateVersionFromEvent(fn, false, 'churchCity'); }}
                    onChange={(e) => { return this.setStateFromEvent(e, 'churchCity'); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                />

                <ValidatedInput
                    containerClass="input_church-state"
                    labelText={i18n.t('general.state')}
                    value={this.state.churchState}
                    name="churchState"
                    placeholder={i18n.t('general.state')}
                    onBlur={(fn) => { this.updateVersionFromEvent(fn, false, 'churchState'); }}
                    onReturnDown={(fn) => { this.updateVersionFromEvent(fn, false, 'churchState'); }}
                    onChange={(e) => { return this.setStateFromEvent(e, 'churchState'); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                />

                <ValidatedInput
                    containerClass="input_church-zip"
                    labelText={i18n.t('general.zip')}
                    value={this.state.churchZip}
                    name="churchZip"
                    placeholder={i18n.t('general.zip')}
                    onBlur={(fn) => { this.updateVersionFromEvent(fn, false, 'churchZip'); }}
                    onReturnDown={(fn) => { this.updateVersionFromEvent(fn, false, 'churchZip'); }}
                    onChange={(e) => { return this.setStateFromEvent(e, 'churchZip'); }}
                    errorMessage=""
                    hasError={false}
                    successMessage=""
                    hasSuccess={false}
                />
            </div>
        );

        return (
            <VersionBox
                name={version.name}
                versionNumber={version.version}
                saving={this.props.versions.inProgress}
                justSaved={this.props.projects.justSaved}
                menuSection="AppSettings"
                menuItem="GeneralInfo"
                previewCssClass="app-settings_general-info"
                previewChild={previewGenInfo}
                configCode={version.configCode}
                showPreview={this.state.showPreview}
                x
            >
                <div id="general-info" className="content-inside" data-qa="general-info-page-content">
                    <h1 id="general-info-header" data-qa="general-info-header">{i18n.t('general.header')}</h1>
                    <p id="general-info-subhead" className="lead" data-qa="general-info-subhead">{i18n.t('general.subtitle')}</p>
                    {!this.props.versions.inProgress && form}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInfo);
